import React, {memo, useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import easing from 'ol/easing';
import {animate as animateMap} from '@mapsight/core/lib/map/actions';
import {FEATURE_SOURCES, MAP} from '@mapsight/ui/src/js/config/constants/controllers';

import {preselectFeatureSelector} from '../../mapsight-glue/store/selectors';
import {useNavPos} from '../../hooks';

import Link from './link';


function NaviWidget() {
	const dispatch = useDispatch();
	const navPos = useNavPos();
	const detailsFeature = useSelector(preselectFeatureSelector);
	const appSource = useSelector(state => state[FEATURE_SOURCES][navPos?.app?.uri || '']);

	const onMapClick = useCallback(
		(event) => {
			if(navPos.map) {
				dispatch(animateMap(MAP, {
					nearest: true,
					duration: 1000,
					easing: easing.easeOut,
					bounds: [1053999.7377, 7093770.4333, 1055626.4132, 7095755.0838],
				}));
				event.stopPropagation();
			}
		},
		[navPos.map]
	);

	if(!navPos.app)
		return null;

	const tourTarget = (detailsFeature?.id || (appSource?.ids && appSource.ids[0]) || '');

	return (<div className="stade-widget stade-widget__navi">
		<ul>
			<li className={`stade-widget__navi__start ${navPos.home ? 'stade-widget__navi--active' : ''}`}><Link to="/">{navPos.app.lang === 'en'?'Home':'Start'}</Link></li>
			<li onClick={onMapClick} className={`stade-widget__navi__map ${navPos.map ? 'stade-widget__navi--active' : ''}`}><Link to={navPos.app.lang === 'en'?'/map':'/karte'}>{navPos.app.lang === 'en'?'Map':'Karte'}</Link></li>
			<li className={`stade-widget__navi__tour ${navPos.deepLink ? 'stade-widget__navi--active' : ''}`}><Link to={'/'+tourTarget}>Tour</Link></li>
			<li className={`stade-widget__navi__list ${navPos.list || navPos.listMorePoi ? 'stade-widget__navi--active' : ''}`}><Link to={navPos.app.lang === 'en'?'/list':'/liste'}>{navPos.app.lang === 'en'?'List':'Liste'}</Link></li>
		</ul>
	</div>);
}

export default memo(NaviWidget);
